import React from 'react'
import Container from '../../../../components/Container'
import { FormPermissionsAssociated } from '../components/Form'
import { namePageTitle, nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const PermissionsAssociatedCreate = (): JSX.Element => (
  <Container
    pageTitle={namePageTitle}
    breadcrumb={breadcrumbCreate}
    tools={[toolsCreate]}
  >
    <div className="form-body">
      <FormPermissionsAssociated typeForm="create" />
    </div>
  </Container>
)

export default PermissionsAssociatedCreate
